<template>
	<el-card>
		<div slot="header" class="clearfix"><el-button type="danger" @click="deleteChange(sels)" :disabled="this.sels.length === 0">批量删除</el-button></div>
		<el-table ref="multipleTable" :data="postList" tooltip-effect="dark" @selection-change="selsChange">
			<el-table-column type="selection" width="55"></el-table-column>
			<!-- 复选框 -->
			<el-table-column prop="id" label="ID" width="50"></el-table-column>
			<el-table-column label="用户" width="150">
				<template slot-scope="scope">
					<div class="flex-align-center">
						<el-avatar :size="30" :src="scope.row.userInfo.avatar"></el-avatar>
						<span style="margin-left: 10px;flex: 1;">{{ scope.row.userInfo.nickname }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
			<el-table-column label="媒体">
				<template slot-scope="scope">
					<div class="post-img-box">
						<img v-if="scope.row.type === 1" v-for="(item, index) in scope.row.media" :key="index" :src="item" />
						<video controls="controls" v-if="scope.row.type === 2" v-for="(item, index) in scope.row.media" :key="index" :src="item"></video>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="read_count" label="阅读量" align="center"></el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="发布时间"></el-table-column>
			<el-table-column label="管理" width="100">
				<template slot-scope="scope">
					<!-- <el-button>编辑</el-button> -->
					<el-popconfirm
						style="margin-left: 5px;"
						confirmButtonText="确定"
						cancelButtonText="取消"
						@confirm="postDel(scope.row.id, scope.$index)"
						icon="el-icon-info"
						iconColor="red"
						title="确定删除？"
					>
						<el-button slot="reference" type="danger">删除</el-button>
					</el-popconfirm>
					<el-popconfirm
							style="margin-left: 5px;"
							confirmButtonText="确定"
							cancelButtonText="取消"
							@confirm="postTuijian(scope.row.id, scope.row.is_tuijian, scope.$index)"
							icon="el-icon-info"
							iconColor="red"
							title="确定推荐？"
					>
						<el-button slot="reference" type="primary">{{ scope.row.is_tuijian==0?'推荐':'取消推荐' }}</el-button>
					</el-popconfirm>
					<el-popconfirm
							style="margin-left: 5px;"
							confirmButtonText="确定"
							cancelButtonText="取消"
							@confirm="postJiajing(scope.row.id, scope.row.is_jinghua, scope.$index)"
							icon="el-icon-info"
							iconColor="red"
							title="确定加精？"
					>
						<el-button slot="reference" type="primary">{{ scope.row.is_jinghua==0?'加精':'取消加精' }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next" :total="postLength"></el-pagination>
	</el-card>
</template>

<script>
export default {
	data() {
		return {
			sels: [], //选中的值显示
			currentPage: 1,
			pagesize: 0,
			postList: [],
			postLength: 0
		};
	},
	created() {
		this.handleCommunityList();
	},
	methods: {
		handleCommunityList() {
			this.$H
				.get('post/list', {
					page: this.currentPage
				})
				.then(res => {
					this.postList = res.result.data;
					this.pagesize = res.result.per_page;
					this.postLength = res.result.total;
				});
		},
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage;
			this.handleCommunityList();
		},
		postDel(id, index) {
			this.$H
				.post('post/del', {
					id: id
				})
				.then(res => {
					if (res.code == 200) {
						this.postList.splice(index, 1);
						this.$message.success('删除成功');
					}
				});
		},
		postTuijian(id, istuijian, index) {
			if (istuijian==0){
				this.$H
						.post('post/tuijian', {
							id: id
						})
						.then(res => {
							if (res.code == 200) {
								this.postList[index].is_tuijian=1;
								this.$message.success('推荐成功');
							}
						});
			}else {
				this.$H
						.post('post/quxiaotuijian', {
							id: id
						})
						.then(res => {
							if (res.code == 200) {
								this.postList[index].is_tuijian=0;
								this.$message.success('取消推荐成功');
							}
						});
			}

		},
		postJiajing(id,isjinghua, index) {
			if (isjinghua==0){
				this.$H
						.post('post/jiajing', {
							id: id
						})
						.then(res => {
							if (res.code == 200) {
								this.postList[index].is_jinghua=1;
								this.$message.success('加精成功');
							}
						});
			}else {
				this.$H
						.post('post/quxiaojiajing', {
							id: id
						})
						.then(res => {
							if (res.code == 200) {
								this.postList[index].is_jinghua=0;
								this.$message.success('取消加精成功');
							}
						});
			}

		},
		selsChange(sels) {
			this.sels = sels;
		},
		deleteChange(index) {
			var ids = this.sels.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
			console.log(ids);
			this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$H
						.post('post/Changedel', {
							id: ids
						})
						.then(res => {
							if (res.code == 200) {
								this.$message.success('删除成功');
								setTimeout(() => {
									location.reload();
								}, 1000);
							}
						});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		}
	}
};
</script>

<style scoped="scoped">
.post-img-box {
	display: flex;
}

.post-img-box > img {
	width: 100px;
	height: 100px;
	margin-right: 5px;
	margin-bottom: 5px;
}

.post-img-box > video {
	width: 100px;
	height: 100px;
	margin-right: 5px;
	margin-bottom: 5px;
}
</style>
